define.alias("ember-math-helpers/helpers/log-e", "media/helpers/log-e");